const successSubtle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7.25" stroke-width="1.5"/><polyline stroke-width="1.5" points="5 7.41 7.16 9.67 11 5.67"/></svg>',
};

export { successSubtle as default };
